module.exports = __webpack_public_path__ + "static/media/logo.03bc9cb5.svg";